import { Passenger } from '@models/micro';

/**
 * CI-23237: Devuelve el primer pasajero (de los seleccionados para check-in) que
 * aun no tiene completa la informacion de contacto obligatoria (email, telefono,
 * fecha de nacimiento, genero). Regla reutilizable en los flujos normal, Standby
 * y Seamless para homologar la validacion previa al envio de check-in.
 *
 * @param passengers Lista de pasajeros seleccionados para check-in.
 * @returns El primer pasajero con contacto incompleto, o undefined si todos estan completos.
 */
export function getIncompleteContactPassenger(passengers: Passenger[]): Passenger | undefined {
  return passengers.find((p) => !p.checkinStatus && !p.isCompleteInformationContact());
}
